"use client"

import { HTMLAttributes, useState } from "react"

import { cn } from "@/lib/utils"

export default function ClientDemoSection2() {
  const [active, setActive] = useState(1)
  return (
    <div className="grid grid-cols-1 gap-x-24 lg:grid-cols-2 lg:items-start">
      <div className="">
        <dl className="mx-auto mt-6 max-w-2xl text-base leading-7 text-slate-600 lg:mx-0 lg:max-w-lg">
          <ClickableSection
            index="01"
            title="Your prospect leaves their contact information"
            desc="If the prospect wants to acquire your boilerplate but is not ready to purchase, they can leave their contact information so you can reach out to them."
            onClick={() => setActive(1)}
            isActive={active === 1}
          />
          <ClickableSection
            index="02"
            title="Contact Your Prospects"
            desc="In your dashboard, you have access to a list of prospects ready to buy your boilerplate. You can obtain their email and X for $3.99 per prospect."
            onClick={() => setActive(2)}
            isActive={active === 2}
          />
          <ClickableSection
            index="03"
            title="You increase your sales!"
            desc="With our lead system, you can contact your prospects and follow up with them to increase your conversion rate and boost your sales."
            onClick={() => setActive(3)}
            isActive={active === 3}
          />
        </dl>
      </div>
      <div
        key={`video-key-${active}`}
        className="border-newPrimary/40 relative mt-10 h-[320px] w-full max-w-2xl overflow-hidden rounded-2xl border-[6px] bg-white"
      >
        {active === 1 ? (
          <video
            className="absolute inset-0 h-full w-full rounded-lg object-cover object-center"
            playsInline
            autoPlay
            loop
            muted
          >
            <source
              src="https://epkyoncdkuzoznax.public.blob.vercel-storage.com/Yanniss%20video%20(14)-g52e4NSiJ6z9HpbaypA3UBUUCl5QvK.mp4"
              type="video/mp4"
            />
          </video>
        ) : active === 3 ? (
          <video
            className="absolute inset-0 h-full w-full rounded-lg object-cover object-center"
            playsInline
            autoPlay
            loop
            muted
          >
            <source
              src="https://epkyoncdkuzoznax.public.blob.vercel-storage.com/Yanniss%20video%20(13)-cQLA4IHCFLPOiJPQTt9zt02bAeTrUz.mp4"
              type="video/mp4"
            />
          </video>
        ) : (
          <video
            className="absolute inset-0 h-full w-full rounded-lg object-cover object-center"
            playsInline
            autoPlay
            loop
            muted
          >
            <source
              src="https://epkyoncdkuzoznax.public.blob.vercel-storage.com/Yanniss%20video%20(15)-otPeBwK4dGz7kiwdD0Y45bVg5r5Iyt.mp4"
              type="video/mp4"
            />
          </video>
        )}
      </div>
    </div>
  )
}

function ClickableSection({
  index,
  title,
  desc,
  isActive = false,
  ...props
}: {
  index: string
  title: string
  desc: string
  isActive: boolean
} & HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      {...props}
      className={cn(
        "relative my-2 flex cursor-pointer flex-col items-start justify-center rounded-lg border border-transparent p-4 transition-all duration-300 ease-in-out hover:bg-primary/10",
        {
          "bg-primary/10": isActive,
        }
      )}
    >
      <dt className="font-display flex items-center font-semibold text-slate-900">
        <span className="mr-3 font-bold text-primary" aria-hidden="true">
          {index}
        </span>
        <h3 className="font-semibold">{title}</h3>
      </dt>
      <dd className="ml-9 inline">{desc}</dd>
    </div>
  )
}
